import { Reveal } from "../shared/Reveal";
import CaseReviewForm from "../shared/CaseReviewForm";
import { useI18n } from "../../i18n";

// Case-review section anchored at #case-review, placed directly after the hero.
export default function CaseReviewSection() {
  const { t } = useI18n();
  return (
    <section id="case-review" className="scroll-mt-28 bg-background py-20 md:py-28" data-testid="case-review-section">
      <div className="container-psv grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <Reveal>
            <span className="eyebrow mb-4 block">{t("cta.caseReview")}</span>
            <h2 className="font-serif font-medium text-primary text-4xl md:text-5xl leading-[1.02] tracking-tight">
              {t("form.heading")}
            </h2>
            <p className="mt-6 text-lg text-secondary-foreground font-light leading-relaxed">
              {t("form.intro")}
            </p>
            <ul className="mt-8 space-y-3">
              {t("hero.trust").map((tp, i) => (
                <li key={i} className="flex items-center gap-3 text-[15px] text-primary/80 font-sans">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent" /> {tp}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <CaseReviewForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
